<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div class="container">
  <h1 class="text-center lifedi-color">บทความ</h1>
  <div class="row mb-4">
    <label for="type"
      class="offset-lg-8 offset-md-6 col-lg-1 col-md-1 col-sm-2 col-2 col-form-label text-right">ประเภท</label>
    <div class="col-lg-3 col-md-5 col-sm-10 col-10">
      <select class="custom-select" id="type" [(ngModel)]="selectedType" (change)="changeType()">
        <option value="0">บทความทั้งหมด</option>
        <option *ngFor="let c of type" [value]="c.CATEGORY_ID">{{c.CATEGORY_NAME}}</option>
      </select>
    </div>
  </div>
  <div class="row" *ngIf="rows?.length > 0">
    <div class="col-lg-3 col-md-4 col-sm-6 mb-4" *ngFor="let item of rows">
      <lifedi-card-box [routerLink]="[item.ARTICAL_ID]" [title]="item.ARTICAL_TITAL" [imageUrl]="item.ARTICAL_PIC"
        [content]="item.ARTICAL_DETAIL" [id]="item.ARTICAL_ID" [date]="item.ARTICAL_DATE" style="outline: none;">
      </lifedi-card-box>
    </div>
  </div>
  <div class="row mt-3 mb-3" *ngIf="rows?.length === 0">
    <h4 class="text-center w-100">
      ยังไม่มีบทความประเภทนี้
    </h4>
  </div>

  <div class="d-flex justify-content-center p-2" *ngIf="rows?.length > 0">
    <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [pageSize]="pageSize" (pageChange)="refresh()">
    </ngb-pagination>
  </div>

  <mat-spinner *ngIf="!rows" class="spinner-center"></mat-spinner>
</div>

<div [ngClass]="rows?.length > 0 ? '' : 'footer'">
  <lifedi-footer *ngIf="rows"></lifedi-footer>
</div>